//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import './style.scss';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { Modal } from '../../components/ui/modal/Modal';
import Button from '../../components/ui/button/Button';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import l1 from '../../assets/emojis/lungs1.png';
import l2 from '../../assets/emojis/lungs2.png';
import stomach3 from '../../assets/emojis/stomach.png';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const healthConcerns = useStore((state) => state.healthConcerns);
  const setHealthConcerns = useStore((state) => state.setHealthConcerns);
  const { onNext, onPrev, currentIndex } = useNav();
  const [next, setNext] = useState(healthConcerns.length > 0);

  useEffect(() => {
    if (healthConcerns.length >= 2 && healthConcerns.includes("I don't have any of These")) {
      setNext(false);
    }
  }, []);

  const handleChange = (value) => {
    if (value.includes("I don't have any of These")) {
      if (value.length === 1) {
        setNext(true);
        onNext();
      } else {
        setNext(false);
        return;
      }
      setNext(false);
    }
    setHealthConcerns(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.healthConcerns.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={healthConcerns} onChange={handleChange}>
          <MultiOption value={"I don't have any of These"}>
            <span>👍</span>
            {t('onboarding.healthConcerns.options.no')}
          </MultiOption>
          <MultiOption value={'Hypertension'}>
            <span>🩸</span>
            {t('onboarding.healthConcerns.options.hypertension')}
          </MultiOption>
          <MultiOption value={'High Cholesterol'}>
            <span>🌭</span>
            {t('onboarding.healthConcerns.options.cholesterol')}
          </MultiOption>
          <MultiOption value={'Obesity'}>
            <span>🍔</span>
            {t('onboarding.healthConcerns.options.obesity')}
          </MultiOption>
          <MultiOption value={'Diabetes'}>
            <span>💉</span>
            {t('onboarding.healthConcerns.options.diabetes')}
          </MultiOption>
          <MultiOption value={'Heart Disease'}>
            <span>❤️</span>
            {t('onboarding.healthConcerns.options.heartDisease')}
          </MultiOption>
          <MultiOption value={'Cancer'}>
            <span>🦠</span>
            {t('onboarding.healthConcerns.options.cancer')}
          </MultiOption>
          <MultiOption value={'Lung Disease'}>
            <img className='emoji' src={l1} alt='lungs' />
            {t('onboarding.healthConcerns.options.lungDisease')}
          </MultiOption>
          <MultiOption value={'Thyroid Disease'}>
            <img className='emoji' src={l2} alt='lungs' />
            {t('onboarding.healthConcerns.options.thyroidDisease')}
          </MultiOption>
          <MultiOption value={'Stomach Disease'}>
            <img className='emoji' src={stomach3} alt='stomach' />
            {t('onboarding.healthConcerns.options.stomachDisease')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.healthConcerns.continue')}
          onClick={() => setIsModalOpen(true)}
        />
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        hasCloseBtn
        title={t('onboarding.healthConcerns.modal.title')}
      >
        <div className='modal-content_new'>
          <Text size='m' regular>
            {t('onboarding.healthConcerns.modal.subTitle')}
          </Text>
          <Button
            className='modal-button_new'
            title={t('onboarding.healthConcerns.modal.continue')}
            onClick={() => {
              Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                page: 'health-concerns',
                answer: healthConcerns.join(', '),
              });
              onNext();
            }}
          />
        </div>
      </Modal>
    </div>
  );
}
export default Page;
